// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e0ca1134] .ant-form-item {\n  display: flex;\n  align-items: center;\n}\n[data-v-e0ca1134] .ant-form-item .ant-form-item-control-wrapper,[data-v-e0ca1134] .ant-form-item .ant-calendar-picker,[data-v-e0ca1134] .ant-form-item .ant-select {\n  flex: 1;\n  overflow: hidden;\n}\n[data-v-e0ca1134] .ant-form-item .ant-form-item-children {\n  display: flex;\n}\n.tagBox[data-v-e0ca1134] {\n  align-items: flex-start;\n}", ""]);
// Exports
module.exports = exports;
